/* SWIPE — transforme les questions (h3 + paragraphes) de la page FAQ en accordéon */
(function () {
  function buildFaq() {
    if (!/faq/i.test(window.location.pathname)) return;
    var root = document.querySelector('#MainContent .rte') || document.querySelector('#MainContent');
    if (!root || root.querySelector('.swipe-faq')) return;
    var questions = root.querySelectorAll('h3');
    if (questions.length < 2) return;

    var intro = root.querySelector('h2');
    if (intro && intro.compareDocumentPosition(questions[0]) & Node.DOCUMENT_POSITION_FOLLOWING) intro.remove();
    var wrapper = document.createElement('div');
    wrapper.className = 'swipe-faq';
    questions[0].parentNode.insertBefore(wrapper, questions[0]);

    questions.forEach(function (h3, i) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = h3.textContent.trim();
      var answer = document.createElement('div');
      answer.className = 'swipe-faq__answer';
      var next = h3.nextElementSibling;
      while (next && next.tagName !== 'H3' && next.tagName !== 'H2') {
        var move = next;
        next = next.nextElementSibling;
        answer.appendChild(move);
      }
      details.appendChild(summary);
      details.appendChild(answer);
      if (i === 0) details.open = true;
      wrapper.appendChild(details);
      h3.remove();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildFaq);
  else buildFaq();
})();

/* Masque le sélecteur de variante inutile ("Default Title") sur les produits à variante unique */
(function () {
  function hideDefault() {
    document.querySelectorAll('variant-picker, .variant-picker').forEach(function (el) {
      if (/Default Title/.test(el.textContent)) el.style.display = 'none';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideDefault);
  else hideDefault();
})();
